module.exports = __webpack_public_path__ + "static/media/soc_flickr.19c5086e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc_flickr.svg
// module id = 429
// module chunks = 0